module.exports = __webpack_public_path__ + "img/cover-fer.e673c18b.png";